import { Base } from ".";
import { bestFitForSolar } from "../sample";

export const BestFitForSolar = ({ building, onClose }) => {
  return (
    <Base
      headerTitle="Best Fit For Solar"
      building={building}
      secondButton="APPROVE NEW SOLAR ASSET"
      data={bestFitForSolar}
      onClose={onClose}
    />
  );
};
